import { hostname } from './hostname';
import EnvironmentNames from '../../interfaces/EnvironmentNames';

export const getEnvUsingWindowLocation = (): EnvironmentNames => {
  if (hostname().includes('fabfitfun')) return EnvironmentNames.PROD;
  if (hostname().includes('fff-qa')) return EnvironmentNames.QA;
  return EnvironmentNames.DEV;
};
